import { SIGN_IN, SIGN_OUT } from '../actions/types'

const INITIAL_STATE = {
  isSignedIn: null,
  googleId: null,
  id: null,
  createdAt: null,
  updatedAt: null,
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SIGN_IN:
      return { ...state, isSignedIn: true, ...action.payload }
    case SIGN_OUT:
      return {
        ...state,
        isSignedIn: false,
        googleId: null,
        id: null,
        createdAt: null,
        updatedAt: null,
      }
    default:
      return state
  }
}
